(() => {
  const getVariantData = (panel) => {
    const variantInput = panel.querySelector("[data-variant-input]");
    const variantScript = panel.querySelector("[data-product-variants]");
    if (!variantInput || !variantScript) return null;

    try {
      const variants = JSON.parse(variantScript.textContent || "[]");
      return variants.find((variant) => String(variant.id) === String(variantInput.value)) || null;
    } catch (_error) {
      return null;
    }
  };

  const syncVariantMedia = (panel) => {
    const variant = getVariantData(panel);
    if (!variant || !variant.image) return;

    const gallery = document.querySelector("[data-scroll-gallery]");
    if (!gallery) return;

    const heroImage = gallery.querySelector("[data-gallery-slide] img");
    if (!heroImage) return;

    // The custom gallery renders only the first product images, while some variant images
    // live later in the product media list. Swap the hero directly to the selected variant.
    heroImage.removeAttribute("srcset");
    heroImage.src = variant.image;
    if (variant.imageAlt) heroImage.alt = variant.imageAlt;

    const viewport = gallery.querySelector("[data-gallery-viewport]");
    if (viewport) {
      if (typeof viewport.scrollTo === "function") viewport.scrollTo({ left: 0, behavior: "auto" });
      else viewport.scrollLeft = 0;
    }
  };

  document.querySelectorAll("[data-product-panel]").forEach((panel) => syncVariantMedia(panel));

  document.addEventListener("click", (event) => {
    const choice = event.target.closest("[data-option-choice]");
    if (!choice) return;
    const panel = choice.closest("[data-product-panel]");
    if (!panel) return;

    // philu-theme.js handles the variant selection first. Sync the gallery on the next frame
    // so the hidden variant ID and price state are already current.
    window.requestAnimationFrame(() => syncVariantMedia(panel));
  });
})();
